(ns app.front.view.admin.permissions
  (:require [app.front.entities :as entities]
            [app.front.view.workspace.get :as ws-get]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(defn- make-command [phase deauthorize?]
  {:comm/command {:command    :admin/authorize-workspace-write
                  :data       (p/assoc-if {:phase-id (:db/id phase)}
                                          :deauthorize? deauthorize?)
                  :on-success [::ws-get/get-for-application-view
                               (-> phase :entity/parent :workspace/id)]}})

(rf/reg-event-fx ::add-admin-write-authorization
  (fn [_ [_ phase]]
    (make-command phase nil)))

(rf/reg-event-fx ::remove-admin-write-authorization
  (fn [_ [_ phase]]
    (make-command phase true)))

(rf/reg-event-fx ::set-property-write-authorization
  (fn [_ [_ property deauthorize?]]
    {:comm/command {:command    :admin/authorize-property-write
                    :data       (p/assoc-if {:property-id (:db/id property)}
                                            :deauthorize? deauthorize?)
                    :on-success [::entities/override-entity-db]}}))
